import { Controller } from "@hotwired/stimulus"
import { Swiper } from 'swiper'
import { Autoplay } from 'swiper/modules'

// Connects to data-controller="event-montage"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.initSwiper()
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.containerTarget, {
      modules: [Autoplay],
      
      // Multiple slides visible for continuous effect
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: false,
      
      // Responsive breakpoints optimized for mobile
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 24,
        }
      },

      // Continuous autoplay like Swiper homepage
      autoplay: {
        delay: 1, // Minimal delay for continuous movement
        disableOnInteraction: false,
        pauseOnMouseEnter: false, // Never pause
        reverseDirection: false,
      },

      // Smooth continuous movement
      speed: 5000, // Very slow, smooth transition for continuous effect
      loop: true,
      loopAdditionalSlides: 3,
      loopFillGroupWithBlank: false,
      
      // Allow free mode for natural scrolling
      freeMode: {
        enabled: true,
        momentum: false,
        sticky: false,
      },
      
      // Grab cursor for better UX
      grabCursor: true,
      
      // No pagination or navigation for clean look
      navigation: false,
      pagination: false,
    })
  }
}